<template>
  <b-modal :id="'errorModal' + _uid"
           class="add-error-modal"
           data-qa="modal"
           :size="size"
           v-model="showModal"
           :hide-footer="hideFooter"
           :title="title"
           :static="staticModal"
           :ok-only="true"
           :ok-title="okTitle"
           header-bg-variant="custom"
           header-text-variant="custom"
           body-bg-variant="custom"
           body-text-variant="custom"
           footer-bg-variant="custom"
           footer-text-variant="custom"
  >
    <b-alert :show="errors.length > 0" variant="danger" class="app-error-view">
      <ul class="error-list">
        <li class="error-item" v-for="(error) in errors" v-bind:key="error.__uuid">{{error.message}}</li>
      </ul>
    </b-alert>
  </b-modal>
</template>

<script>
import MessageBase from './MessageBase'
import { BAlert } from 'bootstrap-vue'

export default {
  name: 'ErrorModal',
  extends: MessageBase,
  components: {
    BAlert
  },
  props: {
    title: {
      type: String,
      default: 'Achtung'
    },
    hideFooter: {
      type: Boolean,
      default: true
    },
    staticModal: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'lg'
    },
    okTitle: {
      type: String,
      default: 'OK'
    }
  },
  computed: {
    showModal: {
      get () {
        return Array.isArray(this.errors) && this.errors.length > 0
      },
      set (value) {
        this.errors = []
      }
    }
  }
}
</script>
